import { Icon } from '@iconify/react/dist/iconify.js';
import './style.css';
import { CRRender } from '@/components/crRender';
const Card = ({ icon, title, value, isAlert, className, children }) => {
  return (
    <div className={`card ${isAlert ? "alert-bg" : ""} ${className}`}>
      <CRRender isRender={!children}>
        <Icon icon={icon} className="card-icon" />
        <div className="card-info">
          <p className="card-title">{title}</p>
          <p className="card-value">{value || "--"}</p>
        </div>
      </CRRender>
      {children}
    </div>
  );
};

export default Card